

export interface AddStopPhraseRequest {
    phrase: string;
}




export interface Aggregator {
    id?: string;
    slug?: string;
    nameEn?: string;
    nameRu?: string;
    logo?: string;
    state?: string;
    createdAt?: string;
    updatedAt?: string;
    meta?: { [key: string]: string; };
}




export interface AggregatorDictResponse {
    id: string;
    slug: string;
    title: string;
    providers: Array<ProviderDictResponse> | null;
}




export const AggregatorSortBy = {
    Id: 'id',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
} as const;
export type AggregatorSortBy = typeof AggregatorSortBy[keyof typeof AggregatorSortBy];




export interface ApplyReactionResponse {
    likesDelta: number;
    dislikesDelta: number;
}




export interface CategoryCollection {
    id: string;
    categorySlug: string;
    collectionId: string;
    collectionName: string;
    localeId?: number;
    createdAt: string;
    updatedAt: string;
}




export interface CategoryCollections {
    items: Array<CategoryCollection>;
}




export interface CollectionGame {
    id: string;
    collectionId: string;
    gameSlug: string;
    gameNameEn: string;
    aggregatorName: string;
    providerName: string;
    gameImageUrl?: string;
    position?: number;
    isManual: boolean;
    rtp?: number;
    createdAt: string;
    updatedAt: string;
}




export interface CollectionGameModification {
    gameSlug: string;
    position?: number;
    rtp?: number;
    modificationType: CollectionGameModification.ModificationTypeEnum;
    isManual: boolean;
}
export namespace CollectionGameModification {
    export const ModificationTypeEnum = {
        Insert: 'INSERT',
        Update: 'UPDATE',
        Delete: 'DELETE'
    } as const;
    export type ModificationTypeEnum = typeof ModificationTypeEnum[keyof typeof ModificationTypeEnum];
}





export interface CollectionPresetResponse {
    id: string;
    name: string;
    parameters: { [key: string]: any; };
    createdAt: string;
    updatedAt: string;
}




export interface CollectionPresetsResponse {
    items: Array<CollectionPresetResponse>;
    total?: number;
    page: number;
    pageSize: number;
    pageCount: number;
}




export const CollectionSortColumn = {
    Id: 'ID',
    Name: 'NAME',
    Category: 'CATEGORY',
    CollectionSource: 'COLLECTION_SOURCE',
    CreatedAt: 'CREATED_AT',
    UpdatedAt: 'UPDATED_AT'
} as const;
export type CollectionSortColumn = typeof CollectionSortColumn[keyof typeof CollectionSortColumn];




export interface CollectionSourceItem {
    id: string;
    name: string;
}




export interface CollectionSourcesResponse {
    items: Array<CollectionSourceItem>;
}




export interface CommentComplaint {
    id: string;
    commentMessage: string;
    commentId: string;
    userId: number;
    gameId: string;
    gameSlug: string;
    gameNameEn: string;
    providerId: string;
    providerName: string;
    aggregatorId: string;
    aggregatorName: string;
    message: string;
    status: CommentComplaintStatus;
    complaintsTotal: number;
    reviewedBy: string | null;
    createdAt: string;
    updatedAt: string;
}
export namespace CommentComplaint {
}





export const CommentComplaintStatus = {
    New: 'new',
    Reviewed: 'reviewed'
} as const;
export type CommentComplaintStatus = typeof CommentComplaintStatus[keyof typeof CommentComplaintStatus];




export interface CommentsBlockSetting {
    endTime?: string;
    moderator?: string;
}




export interface CommentsFrequencySetting {
    minIntervalSec?: number;
    moderator?: string;
}




export const CommentsSortBy = {
    Id: 'id',
    CreatedAt: 'createdAt',
    LikesCount: 'likesCount',
    DislikesCount: 'dislikesCount'
} as const;
export type CommentsSortBy = typeof CommentsSortBy[keyof typeof CommentsSortBy];




export const ComplaintsSortBy = {
    Id: 'id',
    CreatedAt: 'createdAt',
    ComplaintsTotal: 'complaintsTotal'
} as const;
export type ComplaintsSortBy = typeof ComplaintsSortBy[keyof typeof ComplaintsSortBy];




export interface CreateCategoryCollectionRequest {
    collectionId: string;
    localeId: number;
}




export interface CreateCollectionPresetRequest {
    name: string;
    collectionSourceId: string;
    parameters: { [key: string]: any; };
}




export interface CreateGameCollectionRequest {
    collectionSourceId: string;
    name: string;
    params?: { [key: string]: any; };
    games?: Array<CollectionGameModification>;
}




export interface CreateGameCurrencyOverrideRequest {
    aggregatorId: string;
    providerId?: string;
    gameSlug?: string;
    currencies: Array<string>;
}




export interface CreateGamesOfWeekRequest {
    gameId: string;
    presetId: string;
    localeIds?: Array<number>;
}




export interface CreateOrUpdateReactionRequest {
    commentId: string;
    userId: number;
    gameSlug: string;
    gameId: string;
    moderator: string;
    reactionType: ReactionType;
}
export namespace CreateOrUpdateReactionRequest {
}





export interface CreateProviderFeeRequest {
    aggregatorId: string;
    providerId: string;
    fee: number;
    comment?: string | null;
}




export interface CreateTenantBody {
    tenantId: string;
    casinoId?: string;
    name?: string;
}




export interface Game {
    id: string;
    slug: string;
    nameEn: string;
    nameRu?: string;
}




export interface GameComment {
    id: string;
    userId: number | null;
    username: string | null;
    providerId: string;
    providerName: string;
    aggregatorId: string;
    aggregatorName: string;
    gameId: string;
    gameSlug: string;
    gameNameEn: string;
    message: string;
    source: string;
    status: GameCommentStatus;
    moderatedBy: string | null;
    complaintsCount: number;
    likesCount: number;
    dislikesCount: number;
    displayedCreatedAt: string;
    updatedAt: string;
    createdAt: string;
    version: number;
}
export namespace GameComment {
}





export const GameCommentStatus = {
    New: 'new',
    Declined: 'declined',
    Published: 'published',
    Spam: 'spam'
} as const;
export type GameCommentStatus = typeof GameCommentStatus[keyof typeof GameCommentStatus];




export interface GameCurrenciesResponse {
    currencies: Array<string>;
}




export interface GameCurrencyListItem {
    id: string;
    aggregatorId: string;
    providerId?: string;
    gameSlug?: string;
    currencies: Array<string>;
}




export const GameCurrencySortBy = {
    Id: 'id',
    CreatedAt: 'created_at'
} as const;
export type GameCurrencySortBy = typeof GameCurrencySortBy[keyof typeof GameCurrencySortBy];




export interface GameDiscountItem {
    id: string;
    nameEn: string;
    slug: string;
}




export interface GameOfWeekDeleteItemRequest {
    gameId: string;
    presetId: string;
}




export interface GameOfWeekListResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items?: Array<GameOfWeekResponse>;
}




export interface GameOfWeekLocaleItem {
    id: string;
    localeId: number;
    createdAt: string;
    updatedAt: string;
}




export interface GameOfWeekResponse {
    id: string;
    slug: string;
    presetId: string;
    presetSlug: string;
    type: GameOfWeekResponse.TypeEnum;
    createdAt?: string;
    updatedAt?: string;
    locales?: Array<GameOfWeekLocaleItem>;
}
export namespace GameOfWeekResponse {
    export const TypeEnum = {
        Default: 'default',
        Localed: 'localed'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}





export interface GameResponse {
    items?: Array<Game>;
    total?: number;
}




export const GameState = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    Hidden: 'hidden',
    Restricted: 'restricted',
    Deleted: 'deleted'
} as const;
export type GameState = typeof GameState[keyof typeof GameState];




export interface GameStateLocaleOverride {
    localeId: number;
    reason: GameStateReasonOverride;
}
export namespace GameStateLocaleOverride {
}





export interface GameStateOverrides {
    enabled?: Array<GameStateLocaleOverride>;
    disabled?: Array<GameStateLocaleOverride>;
    hidden?: Array<GameStateLocaleOverride>;
    restricted?: Array<GameStateLocaleOverride>;
}




export const GameStateReasonOverride = {
    Default: 'default',
    Aggregator: 'aggregator',
    AggregatorLocale: 'aggregator_locale',
    Provider: 'provider',
    ProviderLocale: 'provider_locale',
    ProviderAggregatorLocale: 'provider_aggregator_locale',
    Locale: 'locale'
} as const;
export type GameStateReasonOverride = typeof GameStateReasonOverride[keyof typeof GameStateReasonOverride];




export interface GameStateResponse {
    slug: string;
    state: GameState;
    reason: GameStateReasonOverride;
    stateOverrides: GameStateOverrides;
}
export namespace GameStateResponse {
}





export interface GamesCollection {
    id: string;
    gameNumber: number;
    categoryName?: string;
    localeId?: number;
    collectionSourceName: string;
    name: string;
    params?: { [key: string]: any; };
    createdAt: string;
    updatedAt: string;
}




export interface HotColdCollection {
    collectionId: string;
    categoryName: string;
}




export interface ModelError {
    code: number;
    title: string;
    detail: string;
    traceId: string;
    timestamp: string;
    meta?: { [key: string]: string; };
}




export interface OffsetPaginatedStopPhrasesResponse {
    items?: Array<StopPhraseResponse>;
    total: number;
    page: number;
    pageSize: number;
    pageCount: number;
}




export interface PaginatedAggregatorResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items: Array<Aggregator>;
}




export interface PaginatedCollectionGamesResponse {
    items?: Array<CollectionGame>;
    total: number;
    page: number;
    pageSize: number;
    pageCount: number;
}




export interface PaginatedCommentComplaintsResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items: Array<CommentComplaint>;
}




export interface PaginatedGameCollectionsResponse {
    items?: Array<GamesCollection>;
    total?: number;
    page?: number;
    pageSize?: number;
    pageCount?: number;
}




export interface PaginatedGameCommentsResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items: Array<GameComment>;
}




export interface PaginatedGameCurrencyResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items: Array<GameCurrencyListItem>;
}




export interface PaginatedProviderDiscountResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items?: Array<ProviderDiscountResponse>;
}




export interface PaginatedProviderFeeResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items: Array<ProviderFeeResponse>;
}




export interface PaginatedProviderResponse {
    page?: number;
    perPage?: number;
    total?: number;
    pageCount?: number;
    items?: Array<Provider>;
}




export interface PaginatedProvidersEnabledRuleResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
    items: Array<ProvidersEnabledRuleResponse>;
}




export interface PaginatedResponse {
    page: number;
    perPage: number;
    total: number;
    pageCount: number;
}




export interface PaginatedStopPhrasesResponse {
    items?: Array<StopPhraseResponse>;
    count: number;
    forwardCursor?: string;
    backwardCursor?: string;
    hasMore: boolean;
}




export interface PresetsDictionaryItem {
    id: string;
    slug: string;
    title: string;
}




export interface Provider {
    id?: string;
    slug?: string;
    nameEn?: string;
    nameRu?: string;
    logo?: string;
    state?: string;
    createdAt?: string;
    updatedAt?: string;
    meta?: { [key: string]: string; };
}




export interface ProviderDictResponse {
    id: string;
    slug: string;
    title: string;
}




export interface ProviderDiscountCreate {
    providerFeeId: string;
    games?: Array<string>;
    discountPercent?: number;
    discountValue?: string;
    startAt: string;
    endAt: string;
    comment?: string | null;
}




export interface ProviderDiscountResponse {
    id: string;
    providerFee: ProviderFeeResponse;
    games: Array<GameDiscountItem>;
    discountPercent: number;
    discountValue: string;
    startAt: string;
    endAt: string;
    state: ProviderDiscountState;
    comment?: string | null;
}
export namespace ProviderDiscountResponse {
}





export const ProviderDiscountSortBy = {
    Id: 'id',
    ProviderFee: 'providerFee',
    DiscountPercent: 'discountPercent',
    DiscountValue: 'discountValue',
    State: 'state',
    StartAt: 'startAt',
    EndAt: 'endAt'
} as const;
export type ProviderDiscountSortBy = typeof ProviderDiscountSortBy[keyof typeof ProviderDiscountSortBy];




export const ProviderDiscountState = {
    New: 'new',
    Active: 'active',
    Expired: 'expired'
} as const;
export type ProviderDiscountState = typeof ProviderDiscountState[keyof typeof ProviderDiscountState];




export interface ProviderDiscountUpdate {
    discountPercent?: number;
    discountValue?: string;
    startAt: string;
    endAt: string;
    comment?: string | null;
}




export interface ProviderFeeDictAggregatorResponse {
    id: string;
    title: string;
    providers: Array<ProviderFeeDictProviderResponse>;
}




export interface ProviderFeeDictProviderResponse {
    id: string;
    title: string;
    fee: number;
    providerFeeId: string;
}




export interface ProviderFeeResponse {
    id: string;
    aggregatorId: string;
    aggregatorName: string;
    providerId: string;
    providerName: string;
    fee: number;
    comment?: string;
}




export const ProviderFeeSortBy = {
    Id: 'id',
    CreatedAt: 'created_at',
    DeletedAt: 'deleted_at'
} as const;
export type ProviderFeeSortBy = typeof ProviderFeeSortBy[keyof typeof ProviderFeeSortBy];




export const ProviderSortBy = {
    Id: 'id',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
} as const;
export type ProviderSortBy = typeof ProviderSortBy[keyof typeof ProviderSortBy];




export interface ProvidersEnabledRuleCreate {
    aggregatorId: string;
    providerId: string;
    minDepositCount: number;
    localeIds: Array<number>;
    state?: ProvidersEnabledRuleState;
}
export namespace ProvidersEnabledRuleCreate {
}





export interface ProvidersEnabledRuleResponse {
    id: string;
    aggregatorId: string;
    providerId: string;
    minDepositCount: number;
    localeIds: Array<number>;
    state: ProvidersEnabledRuleState;
    createdAt: string;
    updatedAt: string;
}
export namespace ProvidersEnabledRuleResponse {
}





export const ProvidersEnabledRuleSortBy = {
    Id: 'id',
    AggregatorId: 'aggregator_id',
    ProviderId: 'provider_id',
    MinDepositCount: 'min_deposit_count',
    State: 'state',
    CreatedAt: 'created_at'
} as const;
export type ProvidersEnabledRuleSortBy = typeof ProvidersEnabledRuleSortBy[keyof typeof ProvidersEnabledRuleSortBy];




export const ProvidersEnabledRuleState = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type ProvidersEnabledRuleState = typeof ProvidersEnabledRuleState[keyof typeof ProvidersEnabledRuleState];




export interface ProvidersEnabledRuleUpdate {
    minDepositCount?: number;
    localeIds?: Array<number> | null;
    state?: ProvidersEnabledRuleState;
}
export namespace ProvidersEnabledRuleUpdate {
}





export const ReactionType = {
    Like: 'like',
    Dislike: 'dislike'
} as const;
export type ReactionType = typeof ReactionType[keyof typeof ReactionType];




export interface ResolveGamesRequest {
    slugs: Array<string>;
}




export interface ResolveGamesResponse {
    slugs: Array<string>;
}




export const SortDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type SortDirection = typeof SortDirection[keyof typeof SortDirection];




export interface StopPhraseResponse {
    id?: string;
    phrase?: string;
    updatedAt?: string;
}




export interface StopPhrasesBatchResponse {
    requestedCount?: number;
    processedCount?: number;
}




export interface Tenant {
    id?: string;
    name?: string;
    state?: string;
    casino_id?: string;
    created_at?: string;
}




export interface UpdateCommentComplaintRequest {
    moderator: string;
    status: CommentComplaintStatus;
}
export namespace UpdateCommentComplaintRequest {
}





export interface UpdateGameCollectionRequest {
    name?: string;
    games?: Array<CollectionGameModification>;
}




export interface UpdateGameCommentRequest {
    moderator: string;
    status?: GameCommentStatus;
    message?: string;
    version?: number;
}
export namespace UpdateGameCommentRequest {
}





export interface UpdateGameCurrencyOverrideRequest {
    currencies: Array<string>;
}




export interface UpdateProviderDiscountCommentRequest {
    comment: string | null;
}




export interface UpdateProviderFeeRequest {
    fee: number;
    comment?: string | null;
}


